<template>
  <section>
    <Feature :title="$t('STATUS_REPORT')" :iconClass="'fa-clone'">
      <FormRowTwo :fieldNameArr="[$t('FUNCTION') + ': ', $t('STATUS') + ': ', $t('BUYER') + ': ', 'Form No. : ']"
        :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <RadioGroup class="Input" v-model="rfqType" size="large" slot="a">
          <Radio label="COMPONENT">{{ $t('QUOTATION') }}</Radio>
          <Radio label="TOOLING">{{ $t('TOOLING') }}</Radio>
          <Radio label="RFQ">{{ $t('RFQ') }}</Radio>
        </RadioGroup>
        <Select class="Select" v-model="status" slot="b">
          <Option v-for="(item, index) in statusList" :value="item.description" :key="index">{{ item.description }}
          </Option>
        </Select>
        <Input class="Input" v-model="buyerAccount" slot="c" />
        <Input class="Input" v-model="formNoInput" search :enter-button="$t('MORE')" @on-search="moreFormNo" slot="d" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('PLANT_CODE') + ': ', $t('VENDOR_CODE') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="plantCode" search :enter-button="$t('MORE')" @on-search="morePlant" slot="a" />
        <Input class="Input" v-model="vendorCode" search :enter-button="$t('MORE')" @on-search="moreVnCode" slot="b" />
        <Input class="Input" v-model="partNo" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="c" />
        <Input class="Input" v-model="vendorPn" search :enter-button="$t('MORE')" @on-search="moreVendorPn" slot="d" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('APPLY_DATE'), '~', $t('APPROVE_DATE'), '~']"
        :fieldWidthArr="[364, 279, 364, 279]" :fieldSpanWidthArr="[102, 17, 102, 17]">>
        <DatePicker class="Input" v-model="applyFromDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="a">
        </DatePicker>
        <DatePicker class="Input" v-model="applyToDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="b">
        </DatePicker>
        <DatePicker class="Input" v-model="approveFromDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="c">
        </DatePicker>
        <DatePicker class="Input" v-model="approveToDate" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" slot="d">
        </DatePicker>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CATEGORY'), $t('HIGH_PRICE')]"  v-if="showCategory"
      :fieldWidthArr="[364, 364]" :fieldSpanWidthArr="[102, 102]">
        <Select class="Select" v-model="category" :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in categorys" :value="item.key" :key="item.key">
            {{ item.value }}
          </Option>
        </Select>
        <Select class="Select" v-model="isHighPrice" :placeholder="$t('CHOOSE')" slot="b">
          <Option value="ALL" label="All"></Option>
          <Option value="false" label="No"></Option>
          <Option value="true" label="Yes"></Option>
        </Select>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('GROUP_KEY')]" v-if="showGroupKey">
        <Input class="Input" v-model="groupKeyInput" search :enter-button="$t('MORE')" @on-search="moreGroupKey" slot="a" />
      </FormRowTwo>
      <ButtonRow>
        <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="info" @click="clear" slot="1">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
    </Feature>
    <Feature v-show="existedQuotationList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <FormRow v-show="showDownload" slot-scope="" :fieldNameArr="['', '']">
        <Button type="primary" @click="download" slot="a">{{ $t('DOWNLOAD') }}</Button>
        <Button v-show="showDownloadSapUploadExcel" type="success" @click="downloadSap" slot="b" style="width:250px">{{
          $t('DOWNLOAD_UPLOAD_SAP_EXCEL') }}</Button>
      </FormRow>
      <TablePage v-if="rfqType == 'COMPONENT'" :tableWidth="windowWidth" :columnsList="quotationColumnList"
        :resultList="quotationList" :pageObj="pageObj" @changePage="changePage"></TablePage>
      <TablePage v-if="rfqType == 'TOOLING'" :tableWidth="windowWidth" :columnsList="toolingQuotationColumnList"
        :resultList="quotationList" :pageObj="pageObj" @changePage="changePage"></TablePage>
      <TablePage v-if="rfqType == 'RFQ'" :tableWidth="windowWidth" :columnsList="rfqQuotationColumnList"
        :resultList="quotationList" :pageObj="pageObj" @changePage="changePage"></TablePage>
    </Feature>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="partNoModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmPartNoModel">
      <Input v-model="partNoValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorPnModel"
      :title="$t('VENDOR_PN_MORE')" @on-ok="confirmVendorPnValue">
      <Input v-model="vendorPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorCodeModel"
      :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmVendorCodeValue">
      <Input v-model="vendorCodeValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="formNoModel"
      :title="$t('FORM_NO_MORE')" @on-ok="confirmFormNoValue">
      <Input v-model="formNoValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="groupKeyModal"
      :title="$t('GROUP_KEY_MORE')" @on-ok="confirmGroupKeyValue">
      <Input v-model="groupKeyValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="plantModel"
      :title="$t('PLANT_MORE')" @on-ok="confirmPlantValue">
      <Input v-model="plantValue" type="textarea" :rows="10" />
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="toolingModel"
      :title="$t('TOOLING_ATTRIBUTES')">
      <ReportToolingCompoment :quotation="quotation" :tooling="tooling" :rfqType="rfqType"
        :plmQuotationDocuments="plmQuotationDocuments" :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles"
        :toolingQuotationType="toolingQuotationType" :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportToolingCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="quotationModel"
      :title="$t('QUOTATION')">
      <ReportOtherCompoment :quotation="quotation" :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportOtherCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationMetalModel" :title="$t('QUOTATION')">
      <ReportMetalCompoment :quotation="quotation" :metalQuotation="metalQuotation" :priceList="priceList"
        :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportMetalCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationPlasticModel" :title="$t('QUOTATION')">
      <ReportPlasticCompoment :quotation="quotation" :plasticQuotation="plasticQuotation" :priceList="priceList"
        :rfqType="rfqType" :plmQuotationDocuments="plmQuotationDocuments"
        :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles" :scalePriceList="scalePriceList"
        :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportPlasticCompoment>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true"
      v-model="quotationPwbModel" :title="$t('QUOTATION')">
      <ReportPwbCompoment :quotation="quotation" :pwbQuotation="pwbQuotation" :priceList="priceList" :rfqType="rfqType"
        :plmQuotationDocuments="plmQuotationDocuments" :cpcToSupplierReferenceFiles="cpcToSupplierReferenceFiles"
        :scalePriceList="scalePriceList" :showSupplierQuotationFiles="showSupplierQuotationFiles">
      </ReportPwbCompoment>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, FloraEditorConfig } from "@/util/common"
import { ToolingMaterial } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import moment from "moment"
import { FileSchemaList } from "@/util/tableTitle"
import FormRowTwo from '@/components/FormRowTwo'
import ReportOtherCompoment from "@/views/quotation/ReportOtherCompoment"
import ReportToolingCompoment from "@/views/quotation/ReportToolingCompoment"
import ReportMetalCompoment from '@/views/quotation/ReportMetalCompoment'
import ReportPlasticCompoment from '@/views/quotation/ReportPlasticCompoment'
import ReportPwbCompoment from '@/views/quotation/ReportPwbCompoment'

export default {
  name: "StatusReport",
  components: {
    PLMDocument,
    FormRowTwo,
    ReportOtherCompoment,
    ReportToolingCompoment,
    ReportMetalCompoment,
    ReportPlasticCompoment,
    ReportPwbCompoment,
  },
  created() {
    const vueInstance = this
    vueInstance.$queryStatusList(vueInstance, 'status-report').then(data => {
      if (data) {
        vueInstance.statusList = data
        vueInstance.clear()
        if (!vueInstance.getStatusReportStatus()) {
          vueInstance.setStatusReportStatus(vueInstance.statusList[0].description)
        }
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    })
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      fileSchemaList: FileSchemaList(this),
      categorys: [
        {
          key: "ALL",
          value: "All",
        }, {
          key: "OTHERS",
          value: 'Others'
        }, {
          key: "PWB",
          value: "PWB",
        }, {
          key: "METAL",
          value: 'Metal Case'
        }, {
          key: "PLASTIC",
          value: 'Plastic Case'
        }
      ],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      statusList: [],
      formNoValue: '',
      groupKeyValue: "",
      partNoValue: '',
      vendorPnValue: '',
      vendorCodeValue: '',
      plantValue: '',
      partNoModel: false,
      vendorPnModel: false,
      vendorCodeModel: false,
      plantModel: false,
      formNoModel: false,
      groupKeyModal: false,
      toolingModel: false,
      tooling: {},
      quotationModel: false,
      quotation: {},
      commentsModal: false,
      comments: '',
      supplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToSupplierReferenceFiles: [],
      scalePriceList: [],
      priceList: [],
      showSupplierQuotationFiles: [],
      quotationMetalModel: false,
      metalQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        rawMaterialType: {
          partNo: '',
          partNoDesc: ''
        },
        rmVendor: {
          vendorCode: ''
        },
        coilCenter: {
          vendorCode: ''
        },
        rmPrice: '',
        rmPriceDate: '',
        rmCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      quotationPlasticModel: false,
      plasticQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        model: '',
        resinType: {
          type: ''
        },
        resinVendor: {
          vendorCode: ''
        },
        resinNo: {
          partNo: '',
          partNoDesc: ''
        },
        distributor: {
          vendorCode: ''
        },
        resinColor: '',
        colorNo: '',
        rmPrice: '',
        rmPriceDate: '',
        dyeCost: '',
        cavity: '',
        tannage: '',
        hourlyRate: '',
        cycleTime: '',
        rmCost: '',
        injectingCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      quotationPwbModel: false,
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: "",
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 0,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: "",
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: "",
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      toolingQuotationType: '',
      materialColumn: ToolingMaterial(this),
      moldColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'material'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'rawMaterialPrice'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_PROCESSING_FEE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'processingFee'
        }
      ],
      engineeringColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_TL_QUANTITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'quantity'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_WEIGHT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'weight'
        }
      ],
      quotationList: [],
      quotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: "center",
          render: (h, params) => {
            if (params.row.deletable) {
              return h("Icon", {
                props: {
                  type: "md-close-circle",
                  size: 28,
                },
                class: "text-delta-red",
                on: {
                  click: () => {
                    this.toggleLoading(true)
                    this.$quotationHttp
                      .post("/cpc/delete", {
                        quotationRequestList: [{
                          formNo: params.row.formNo,
                          comments: "Status Report Delete"
                        }]
                      })
                      .then((response) => {
                        this.quotationList.splice(params.index, 1)
                        this.toggleLoading(false)
                      })
                      .catch((error) => {
                        this.toggleLoading(false)
                        if (error.response.status == 444) {
                          let text = this.$buildErrorMessage(error)
                          this.$Swal.fire({
                            icon: "error",
                            title: Translate("COMMON_MESSAGE_ERROR"),
                            text,
                          })
                        }
                      })
                  },
                },
              })
            } else {
              return ""
            }
          },
        },
        {
          title: this.$t("FORM_NO_SUPPLIER"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.hasSupplierHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.uuid = params.row.uuid;
                  this.formNo = params.row.formNo;
                  this.toggleLoading(true);
                  if (params.row.category == "OTHERS") {
                    this.$searchSupplierOthers(this).then(vueInstance => {
                      vueInstance.quotationModel = true;
                      vueInstance.toggleLoading(false);
                    })
                  }
                  if (params.row.category == "PWB") {
                    this.$searchSupplierPwb(this).then(vueInstance => {
                      vueInstance.quotationPwbModel = true;
                      vueInstance.toggleLoading(false);
                    })
                  }
                  if (params.row.category == "METAL") {
                    this.$searchSupplierMetal(this, true).then(vueInstance => {
                      vueInstance.quotationMetalModel = true;
                      vueInstance.toggleLoading(false);
                    })
                  }
                  if (params.row.category == "PLASTIC") {
                    this.$searchSupplierPlastic(this, true).then(vueInstance => {
                      vueInstance.quotationPlasticModel = true;
                      vueInstance.toggleLoading(false);
                    })
                  }
                },
              },
            }, params.row.formNo);
          }
        },
        {
          title: this.$t("FORM_NO_CPC"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailCpc) {
              return "";
            }
            if (!params.row.hasCpcHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_CPC_DETAIL",
                    params: {
                      formNo: params.row.formNo,
                      rfqType: params.row.rfqType
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          title: this.$t("FORM_NO_HIGH_PRICE"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailHighPrice) {
              return "";
            }
            if (!params.row.hasHighPriceHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_HIGH_PRICE_DETAIL",
                    params: {
                      formNo: params.row.formNo
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "category",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqNo",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.rfqType) {
              return h("span", {}, params.row.rfqType.description)
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          render: (h, params) => {
            let partNo = params.row.partNo != undefined ? params.row.partNo : ""
            let partDesc = params.row.partDesc != undefined ? params.row.partDesc : ""
            let text = partNo + "<br>" + partDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 159,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "vendorPart",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMPLETE') + '<br>' + this.$t('DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "completeDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quoteDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('SUPPLIER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "supplierProcessDay",
          width: 85,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('CPC')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "cpcProcessDay",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum == "SUCCESS") {
              return h('div', [
                h('Button', {
                  props: { type: 'success', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else if (params.row.status.statusViewEnum == "FAIL") {
              return h('div', [
                h('Button', {
                  props: { type: 'error', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else {
              return h("span", {}, params.row.status.description)
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENT_USER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          align: "center",
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.currentAccountList.join("<br>")
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('BUYER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "buyerAccount",
          width: 80,
          align: "center",
        },
        {
          title: this.$t("ERROR_MESSAGE"),
          width: 200,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum !== "FAIL") {
              return "";
            }
            if (!params.row.canResend) {
              return h("div", [
                h("p", {}, params.row.errorMessage)
              ]);
            }
            return h("div", [
              h("p", {}, params.row.errorMessage),
              h("Button", {
                props: {
                  type: "primary",
                  shape: "circle",
                  size: "small"
                },
                style: {
                  width: "80%"
                },
                on: {
                  click: () => {
                    this.toggleLoading(true);
                    this.$quotationHttp
                      .put("/status-report/resend/" + params.row.formNo)
                      .then(response => {
                        this.quotationList.splice(params.index, 1);
                      })
                      .catch(error => {
                        if (error.response.status == 444) {
                          this.pageObj.page = this.pageObj.page - 1;
                          this.search(false);
                          this.$Swal.fire({
                            icon: "error",
                            title: Translate("COMMON_MESSAGE_ERROR"),
                            text: this.$buildErrorMessage(error)
                          });
                        }
                      })
                      .finally(() => {
                        this.toggleLoading(false);
                      });
                  },
                },
              }, "Resend")
            ]);
          }
        }
      ],
      toolingQuotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: "center",
          render: (h, params) => {
            if (params.row.deletable) {
              return h("Icon", {
                props: {
                  type: "md-close-circle",
                  size: 28,
                },
                class: "text-delta-red",
                on: {
                  click: () => {
                    this.toggleLoading(true)
                    this.$quotationHttp
                      .post("/cpc/tooling/delete", {
                        quotationRequestList: [{
                          formNo: params.row.formNo,
                          comments: "Status Report Delete"
                        }]
                      })
                      .then((response) => {
                        this.quotationList.splice(params.index, 1)
                        this.toggleLoading(false)
                      })
                      .catch((error) => {
                        this.toggleLoading(false)
                        if (error.response.status == 444) {
                          let text = this.$buildErrorMessage(error)
                          this.$Swal.fire({
                            icon: "error",
                            title: Translate("COMMON_MESSAGE_ERROR"),
                            text,
                          })
                        }
                      })
                  },
                },
              })
            } else {
              return ""
            }
          },
        },
        {
          title: this.$t("FORM_NO_SUPPLIER"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.hasSupplierHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.toolingQuotationType = params.row.toolingQuotationType;
                  let isSupplier = false;
                  if (params.row.status.description == "Supplier") {
                    isSupplier = true;
                  }
                  this.price = "";
                  this.comments = "";
                  this.supplierQuotationFiles = [];
                  this.showSupplierQuotationFiles = [];
                  this.cpcToSupplierReferenceFiles = [];
                  this.toggleLoading(true);
                  this.$quotationHttp
                    .get("supplier/detail/" + params.row.uuid)
                    .then(response => {
                      this.quotation = response.data;
                      if (this.quotation.supplierQuotationFiles) {
                        this.supplierQuotationFiles = this.quotation.supplierQuotationFiles;
                        this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted);
                      }
                      if (this.quotation.cpcToSupplierReferenceFiles) {
                        this.cpcToSupplierReferenceFiles = this.quotation.cpcToSupplierReferenceFiles.filter(attachment => !attachment.deleted);
                      } else {
                        this.quotation.cpcToSupplierReferenceFiles = [];
                      }
                      if (this.quotation.price) {
                        this.price = this.quotation.price;
                      }
                      if (this.quotation.comments) {
                        this.comments = this.quotation.comments;
                      }
                    })
                    .catch(error => {
                      console.error(error);
                      AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR")).then(() => {});
                    })
                    .finally(() => {
                      this.toggleLoading(false);
                    });
                  this.$readTooling(this, params.row.formNo, isSupplier)
                    .then(data => {
                      this.toolingModel = true;
                      this.tooling = data;
                      if (this.tooling.attribute == undefined) {
                        this.tooling.attribute = {
                          leadTime: '',
                          cavity: '',
                          lifeTime: '',
                          cycleTime: '',
                          length: '',
                          machineTonnage: '',
                          totalWeight: '',
                          width: '',
                          baseMaterial: '',
                          otherAccessories: '',
                          height: '',
                          managementProfit: '',
                          designAndTestingPrice: '',
                          otherAccessoryTotalPrice: '',
                          formworkPrice: '',
                          coldHotRunner: '',
                          numberOfStep: '',
                          numberOfSlider: '',
                          dryWetProcess: '',
                          molds: [],
                          engineerings: []
                        };
                      }
                      if (this.tooling.attribute.molds == undefined) {
                        this.tooling.attribute.molds = [];
                        this.molds = [];
                      } else {
                        this.molds = this.tooling.attribute.molds;
                      }
                      if (this.tooling.attribute.engineerings == undefined) {
                        this.tooling.attribute.engineerings = [];
                        this.engineerings = [];
                      } else {
                        this.engineerings = this.tooling.attribute.engineerings;
                      }
                      if (this.tooling.materials == undefined) {
                        this.tooling.materials = [];
                      }
                      if (this.tooling.attachments == undefined) {
                        this.tooling.attachments = [];
                      }
                    })
                    .catch(error => {
                      console.error(error);
                      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {});
                    })
                    .finally(() => {
                      this.toggleLoading(false);
                    });
                },
              },
            }, params.row.formNo);
          }
        },
        {
          title: this.$t("FORM_NO_CPC"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailCpc) {
              return "";
            }
            if (!params.row.hasCpcHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_CPC_DETAIL",
                    params: {
                      formNo: params.row.formNo,
                      rfqType: params.row.rfqType
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          title: this.$t("FORM_NO_HIGH_PRICE"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailHighPrice) {
              return "";
            }
            if (!params.row.hasHighPriceHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_HIHG_PRICE_DETAIL",
                    params: {
                      formNo: params.row.formNo
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.rfqType) {
              return h("span", {}, params.row.rfqType.description + '(' + params.row.toolingQuotationType + ')')
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TOOLING_ID')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.partNo
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 159,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMPLETE') + '<br>' + this.$t('DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "completeDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quoteDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('SUPPLIER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "supplierProcessDay",
          width: 85,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('CPC')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "cpcProcessDay",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum == "SUCCESS") {
              return h('div', [
                h('Button', {
                  props: { type: 'success', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else if (params.row.status.statusViewEnum == "FAIL") {
              return h('div', [
                h('Button', {
                  props: { type: 'error', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else {
              return h("span", {}, params.row.status.description)
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENT_USER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          align: "center",
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.currentAccountList.join("<br>")
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('BUYER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "buyerAccount",
          width: 80,
          align: "center",
        },
        {
          title: this.$t("ERROR_MESSAGE"),
          width: 200,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum !== "FAIL") {
              return "";
            }
            if (!this.quotationList[params.index].canResend) {
              return h("div", [
                h("p", {}, params.row.errorMessage)
              ]);
            }
            return h("div", [
              h("p", {}, params.row.errorMessage),
              h("Button", {
                props: {
                  type: "primary",
                  shape: "circle",
                  size: "small"
                },
                style: {
                  width: "80%"
                },
                on: {
                  click: () => {
                    this.toggleLoading(true);
                    this.$quotationHttp
                      .put("/status-report/resend/tooling/" + params.row.groupId)
                      .then(response => {
                        this.quotationList.forEach(quotation => {
                          if (quotation.groupId !== params.row.groupId) {
                            return;
                          }
                          this.$set(quotation, "canResend", false);
                        });
                      })
                      .catch(error => {
                        if (error.response.status == 444) {
                          this.pageObj.page = this.pageObj.page - 1;
                          this.search(false);
                          this.$Swal.fire({
                            icon: "error",
                            title: Translate("COMMON_MESSAGE_ERROR"),
                            text: this.$buildErrorMessage(error)
                          });
                        }
                      })
                      .finally(() => {
                        this.toggleLoading(false);
                      });
                  },
                },
              }, "Resend")
            ]);
          }
        }
      ],
      rfqQuotationColumnList: [
        {
          title: this.$t("ACTION"),
          width: 60,
          align: "center",
          render: (h, params) => {
            return "";
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_KEY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetail) {
              return h("span", {}, params.row.groupId)
            } else {
              return h("a", {
                attrs: { style: "color:#46A3FF" },
                on: {
                  click: () => {
                    this.toggleLoading(true)
                    this.setStatusReportGroupId(params.row.groupId)
                    this.$router.push({ name: 'RFQ_STATUS_REPORT' })
                  },
                },
              }, params.row.groupId)
            }
          }
        },
        {
          title: this.$t("FORM_NO_CPC"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailCpc) {
              return "";
            }
            if (!params.row.hasCpcHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_CPC_DETAIL",
                    params: {
                      formNo: params.row.formNo,
                      rfqType: params.row.rfqType
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          title: this.$t("FORM_NO_HIGH_PRICE"),
          width: 140,
          align: "center",
          render: (h, params) => {
            if (!params.row.showDetailHighPrice) {
              return "";
            }
            if (!params.row.hasHighPriceHyperlink) {
              return h("span", {}, params.row.formNo);
            }
            return h("a", {
              style: {
                color: "#46A3FF"
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: "STATUS_REPORT_HIHG_PRICE_DETAIL",
                    params: {
                      formNo: params.row.formNo
                    }
                  });
                }
              }
            }, params.row.formNo);
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqNo",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.rfqType) {
              return h("span", {}, params.row.rfqType.description)
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          render: (h, params) => {
            let partNo = params.row.partNo != undefined ? params.row.partNo : ""
            let partDesc = params.row.partDesc != undefined ? params.row.partDesc : ""
            let text = partNo + "<br>" + partDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 159,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "vendorPart",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMPLETE') + '<br>' + this.$t('DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "completeDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "rfqDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quoteDate",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('SUPPLIER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "supplierProcessDay",
          width: 85,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_DAYS') + '<br>' + this.$t('CPC')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "cpcProcessDay",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum == "SUCCESS") {
              return h('div', [
                h('Button', {
                  props: { type: 'success', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else if (params.row.status.statusViewEnum == "FAIL") {
              return h('div', [
                h('Button', {
                  props: { type: 'error', shape: "circle" },
                  style: { width: '80%' },
                  size: "small"
                }, params.row.status.description)]);
            } else {
              return h("span", {}, params.row.status.description)
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENT_USER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          align: "center",
          render: (h, params) => {
            return h('div', {
              domProps: {
                innerHTML: params.row.currentAccountList.join("<br>")
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('BUYER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "buyerAccount",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          align: "center",
          render: (h, params) => {
            if (params.row.status.statusViewEnum !== "FAIL") {
              return "";
            }
            if (!params.row.canResend) {
              return h("div", [
                h("p", {}, params.row.errorMessage)
              ]);
            }
            return h("div", [
              h("p", {}, params.row.errorMessage),
              h("Button", {
                props: {
                  type: "primary",
                  shape: "circle",
                  size: "small"
                },
                style: {
                  width: "80%"
                },
                on: {
                  click: () => {
                    this.toggleLoading(true);
                    this.$quotationHttp
                      .put("/status-report/resend/" + params.row.formNo)
                      .then(response => {
                        this.quotationList.splice(params.index, 1);
                      })
                      .catch(error => {
                        if (error.response.status == 444) {
                          this.pageObj.page = this.pageObj.page - 1;
                          this.search(false);
                          this.$Swal.fire({
                            icon: "error",
                            title: Translate("COMMON_MESSAGE_ERROR"),
                            text: this.$buildErrorMessage(error)
                          });
                        }
                      })
                      .finally(() => {
                        this.toggleLoading(false);
                      });
                  },
                },
              }, "Resend")
            ]);
          }
        }
      ]
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getStatusReportRfqType", "getStatusReportStatus", "getStatusReportBuyer",
      "getStatusReportFormNo", "getStatusReportPlantCode", "getStatusReportVendorCode", "getStatusReportPartNo", "getStatusReportVendorPn",
      "getStatusReportApplyFromDate", "getStatusReportApplyToDate", "getStatusReportApproveFromDate", "getStatusReportApproveToDate", "getModalSize", "getWindowsWidth",
      "getStatusReportCategory", "getStatusReportIsHighPrice", "getStatusReportGroupId"]),
    ...mapActions(["toggleLoading", "setQuotationList", "setSupplierQuotationId", "setStatusReportRfqType", "setStatusReportStatus", "setStatusReportBuyer",
      "setStatusReportFormNo", "setStatusReportPlantCode", "setStatusReportVendorCode", "setStatusReportPartNo", "setStatusReportVendorPn",
      "setStatusReportApplyFromDate", "setStatusReportApplyToDate", "setStatusReportApproveFromDate", "setStatusReportApproveToDate", "setStatusReportGroupId",
      "setStatusReportCategory", "setStatusReportIsHighPrice", "setStatusReportGroupId"]),
    moreDeltaPn() {
      this.partNoModel = true
    },
    moreVendorPn() {
      this.vendorPnModel = true
    },
    moreVnCode() {
      this.vendorCodeModel = true
    },
    morePlant() {
      this.plantModel = true
    },
    moreFormNo() {
      this.formNoModel = true
    },
    moreGroupKey() {
      this.groupKeyModal = true;
    },
    openComments() {
      this.commentsModal = true
    },
    confirmPartNoModel() {
      this.partNoValue.split('\n').forEach(a => {
        this.setStatusReportPartNo(this.getStatusReportPartNo().concat(a.trim() + ";"))
      })
      this.setStatusReportPartNo(this.getStatusReportPartNo().substr(0, this.getStatusReportPartNo().length - 1))
    },
    confirmVendorPnValue() {
      this.vendorPnValue.split('\n').forEach(a => {
        this.setStatusReportVendorPn(this.getStatusReportVendorPn().concat(a.trim() + ";"))
      })
      this.setStatusReportVendorPn(this.getStatusReportVendorPn().substr(0, this.getStatusReportVendorPn().length - 1))
    },
    confirmVendorCodeValue() {
      this.vendorCodeValue.split('\n').forEach(a => {
        this.setStatusReportVendorCode(this.getStatusReportVendorCode().concat(a.trim() + ";"))
      })
      this.setStatusReportVendorCode(this.getStatusReportVendorCode().substr(0, this.getStatusReportVendorCode().length - 1))
    },
    confirmFormNoValue() {
      this.formNoValue.split('\n').forEach(a => {
        this.setStatusReportFormNo(this.getStatusReportFormNo().concat(a.trim() + ";"))
      })
      this.setStatusReportFormNo(this.getStatusReportFormNo().substr(0, this.getStatusReportFormNo().length - 1))
    },
    confirmGroupKeyValue() {
      this.groupKeyValue.split("\n").forEach(a => {
        this.setStatusReportGroupId(this.getStatusReportGroupId().concat(a.trim() + ";"));
      });
      this.setStatusReportGroupId(this.getStatusReportGroupId().substr(0, this.getStatusReportGroupId().length - 1));
    },
    confirmPlantValue() {
      this.plantValue.split('\n').forEach(a => {
        this.setStatusReportPlantCode(this.getStatusReportPlantCode().concat(a.trim() + ";"))
      })
      this.setStatusReportPlantCode(this.getStatusReportPlantCode().substr(0, this.getStatusReportPlantCode().length - 1))
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    search(init) {
      const vueInstance = this
      if (!vueInstance.getStatusReportStatus()) {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      } else {
        if (init) {
          vueInstance.pageObj = {
            "page": 0,
            "totalPage": 0,
            "totalCount": 0,
            "pageSize": 20
          }
        }
        if (this.getUserProfile().systemRoles.includes("DATA_CONTROL")
          && (vueInstance.getStatusReportApproveFromDate() == "" || vueInstance.getStatusReportApproveToDate() == "")) {
          AlertInfo(vueInstance, vueInstance.$t('PLEASE_KEY_IN_APPROVE_DATE') + " <br>").then(() => {
          })
        } else {
          vueInstance.quotationList = []
          vueInstance.toggleLoading(true)
          vueInstance.$queryQuotationMaster(vueInstance, buildCriteria(vueInstance), "status-report", vueInstance.pageObj).then(data => {
            vueInstance.toggleLoading(false)
            if (data) {
              vueInstance.quotationList = data._embedded.quotationStatusReportDtoResourceList
              vueInstance.pageObj = {
                "page": data.page.number + 1,
                "totalPage": data.page.totalPages,
                "totalCount": data.page.totalElements,
                "pageSize": data.page.size
              }
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
          })
        }
      }
    },
    download() {
      this.$downloadExcel(this, "status-report", buildCriteria(this), "")
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    downloadSap() {
      const vueInstance = this
      let criteria = buildCriteria(vueInstance)
      criteria.status = "FAIL"
      vueInstance.$downloadExcel(vueInstance, "status-report/sap", criteria, "")
    },
    downloadToolingAttachment(row) {
      this.$downloadToolingAttachment(this, this.quotation.uuid, row.uuid)
    },
    clear() {
      this.setStatusReportRfqType('COMPONENT')
      this.setStatusReportStatus(this.statusList[0].description)
      this.setStatusReportBuyer('')
      this.setStatusReportFormNo('')
      this.setStatusReportPlantCode('')
      this.setStatusReportPartNo('')
      this.setStatusReportVendorPn('')
      this.setStatusReportVendorCode('')
      this.setStatusReportApplyToDate('')
      this.setStatusReportApplyFromDate('')
      this.setStatusReportApproveFromDate('')
      this.setStatusReportApproveToDate('')
      this.formNoValue = ''
      this.groupKeyValue = "";
      this.plantValue = ''
      this.partNoValue = ''
      this.vendorPnValue = ''
      this.vendorCodeValue = ''
      this.setStatusReportCategory('ALL')
    },
  },
  computed: {
    existedQuotationList() {
      return this.quotationList.length > 0
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    hasComments() {
      return this.comments != ""
    },
    supplierAttachmentExited() {
      return this.supplierQuotationFiles && this.supplierQuotationFiles.length > 0
    },
    quotationDocumentView() {
      return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
    },
    cpcToSupplierReferenceFilesExited() {
      return this.cpcToSupplierReferenceFiles && this.cpcToSupplierReferenceFiles.length > 0
    },
    showDownload() {
      return this.getUserProfile().systemRoles && (this.getUserProfile().systemRoles.includes("CPC") || this.getUserProfile().systemRoles.includes("SUPERVISOR") || this.getUserProfile().systemRoles.includes("DATA_CONTROL"))
    },
    showDownloadSapUploadExcel() {
      return this.getUserProfile().systemRoles && this.getUserProfile().systemRoles.includes("DATA_CONTROL")
    },
    toolingQuotationFileView() {
      return this.tooling.attachments && this.tooling.attachments.length > 0
    },
    showCategory() {
      return this.rfqType === "COMPONENT";
    },
    showGroupKey() {
      return this.rfqType === "RFQ";
    },
    rfqType: {
      get() {
        return this.getStatusReportRfqType()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportRfqType(value)
      }
    },
    status: {
      get() {
        return this.getStatusReportStatus()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportStatus(value)
      }
    },
    buyerAccount: {
      get() {
        return this.getStatusReportBuyer()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportBuyer(value.trim())
      }
    },
    formNoInput: {
      get() {
        return this.getStatusReportFormNo()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportFormNo(value.trim())
      }
    },
    plantCode: {
      get() {
        return this.getStatusReportPlantCode()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportPlantCode(value.trim())
      }
    },
    partNo: {
      get() {
        return this.getStatusReportPartNo()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportPartNo(value.trim())
      }
    },
    vendorPn: {
      get() {
        return this.getStatusReportVendorPn()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportVendorPn(value.trim())
      }
    },
    vendorCode: {
      get() {
        this.quotationList = []
        return this.getStatusReportVendorCode()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportVendorCode(value.trim())
      }
    },
    applyFromDate: {
      get() {
        return this.getStatusReportApplyFromDate()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportApplyFromDate(value)
      }
    },
    applyToDate: {
      get() {
        return this.getStatusReportApplyToDate()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportApplyToDate(value)
      }
    },
    approveFromDate: {
      get() {
        return this.getStatusReportApproveFromDate()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportApproveFromDate(value)
      }
    },
    approveToDate: {
      get() {
        return this.getStatusReportApproveToDate()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportApproveToDate(value)
      }
    },
    category: {
      get() {
        return this.getStatusReportCategory()
      },
      set(value) {
        this.quotationList = []
        return this.setStatusReportCategory(value)
      }
    },
    isHighPrice: {
      get() {
        return this.getStatusReportIsHighPrice();
      },
      set(value) {
        this.quotationList = [];
        return this.setStatusReportIsHighPrice(value);
      }
    },
    groupKeyInput: {
      get() {
        return this.getStatusReportGroupId();
      },
      set(value) {
        this.quotationList = [];
        return this.setStatusReportGroupId(value);
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function buildCriteria(vueInstance) {
  let partNoArray = []
  vueInstance.getStatusReportPartNo().split(';').forEach(a => {
    partNoArray.push(a)
  })

  let vendorPnArray = []
  vueInstance.getStatusReportVendorPn().split(';').forEach(a => {
    vendorPnArray.push(a)
  })

  let vendorCodeArray = []
  vueInstance.getStatusReportVendorCode().split(';').forEach(a => {
    vendorCodeArray.push(a)
  })

  let plantArray = []
  vueInstance.getStatusReportPlantCode().split(';').forEach(a => {
    plantArray.push(a)
  })

  let formNoArray = []
  vueInstance.getStatusReportFormNo().split(';').forEach(a => {
    formNoArray.push(a)
  })

  let groupKeyArray = [];
  if (vueInstance.groupKeyInput) {
    vueInstance.groupKeyInput.split(";").forEach(a => {
      groupKeyArray.push(a);
    });
  }

  return {
    "rfqType": vueInstance.getStatusReportRfqType(),
    "status": vueInstance.statusList.find(status => status.description == vueInstance.getStatusReportStatus())['statusViewEnum'],
    "buyerAccount": vueInstance.getStatusReportBuyer(),
    "formNo": vueInstance.getStatusReportFormNo() == "" ? [] : formNoArray,
    "deltaPartNos": vueInstance.getStatusReportPartNo() == "" ? [] : partNoArray,
    "vendorPartNos": vueInstance.getStatusReportVendorPn() == "" ? [] : vendorPnArray,
    "vendorCodes": vueInstance.getStatusReportVendorCode() == "" ? [] : vendorCodeArray,
    "plantCodes": vueInstance.getStatusReportPlantCode() == "" ? [] : plantArray,
    "fromRfqDate": vueInstance.getStatusReportApplyFromDate() == "" ? null : moment(vueInstance.getStatusReportApplyFromDate()).format('YYYY-MM-DD'),
    "toRfqDate": vueInstance.getStatusReportApplyToDate() == "" ? null : moment(vueInstance.getStatusReportApplyToDate()).format('YYYY-MM-DD'),
    "fromApproveDate": vueInstance.getStatusReportApproveFromDate() == "" ? null : moment(vueInstance.getStatusReportApproveFromDate()).format('YYYY-MM-DD'),
    "toApproveDate": vueInstance.getStatusReportApproveToDate() == "" ? null : moment(vueInstance.getStatusReportApproveToDate()).format('YYYY-MM-DD'),
    "category": vueInstance.getStatusReportCategory() == "ALL" || vueInstance.rfqType !== 'COMPONENT' ? null : vueInstance.getStatusReportCategory(),
    "isHighPrice": vueInstance.getStatusReportIsHighPrice() == "ALL" ? null : vueInstance.getStatusReportIsHighPrice(),
    "groupIdList": groupKeyArray
  }
}
</script>

<style scoped></style>
